import { NavLink, useLocation, useParams } from "react-router";
import { useDemandeByIdQuery } from "../../stores/OkOkStore";
import { useAuth } from "../../contexts/auth/useAuth";

import DemandeItem from "../../components/Demandes/DemandeItemComponent";
import DemandeManage from "../../components/Demandes/DemandeManage";
import { roles } from "../../types/Users";
import { useTrads } from "../../contexts/trads/useTrads";
import type { LocationState } from "../../types/QueryParameters";

function Demande() {
    const params = useParams();
    const { data:demande, error, isLoading } = useDemandeByIdQuery(params.demandeId??"0");
    const {hasRole} =  useAuth();
    const location = useLocation();
    const state=location.state as LocationState | undefined;
    const {translate}=useTrads();

    return (
        error ? (
            <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>
        ) : isLoading ? (
            <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>
        ) : demande ? (
            <>
            {state?.modified && <p className="p-3 mb-2 bg-success text-white">{translate('msg_demande_update')}</p>}
            <nav>
                <NavLink to={`/demande/${demande.id.toString()}/edit`}>{translate('btn_edit')}</NavLink>
            </nav>
            <DemandeItem demande={demande} hideuser={hasRole(roles.Beneficiaires)}  /> 
            {hasRole(roles.Operators)?
            <DemandeManage demandeParam={demande}></DemandeManage>
            :null}

            {(hasRole(roles.Administrators) && demande.statut=="accepte")?
                <div className="qrCode">
                    <img width={300} height={300} src={`/ws/demande/${demande.id.toString()}/qrcode`} alt="qrcode" />
                </div>
            :null}

            </>
        ):null
            
    );
}
export default Demande;